import { JSX, ComponentChildren }	from "preact";

import { Dom }	from "ts-base/web/dom";

export type FormRowProps = Readonly<{
	customClass?:	string,
	children:		ComponentChildren,
}>;

export type FormRowType	= "normal"|"form";

export const FormRow = ({ customClass, children }:FormRowProps):JSX.Element =>
	<div class={Dom.classes(
		"FormRow",
		customClass
	)}>
		{children}
	</div>;
